import { render, staticRenderFns } from "./opcHda.vue?vue&type=template&id=c5fb90a0&scoped=true"
import script from "./opcHda.vue?vue&type=script&lang=js"
export * from "./opcHda.vue?vue&type=script&lang=js"
import style0 from "./opcHda.vue?vue&type=style&index=0&id=c5fb90a0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5fb90a0",
  null
  
)

export default component.exports